import React from "react";

const Education: React.FC = () => {
  const education = [
    {
      id: 1,
      degree: "Ingeniería en Sistemas Computacionales",
      institution: "ITM (Instituto Tecnológico de Mérida)",
      period: "2018 - 2023",
      location: "Mérida Yucatán, México",
      description:
        "Formación integral en desarrollo de software, administración de sistemas y redes, con énfasis en soluciones empresariales y ciberseguridad.",
      achievements: [
        "Promedio final: 8.8",
        "Proyecto destacado: Sistema de Inventario Activo para Pymes",
      ],
      courses: [
        "Arquitectura de Software",
        "Bases de Datos Avanzadas",
        "Redes de Computadoras",
        "Inteligencia Artificial",
        "Seguridad Informática",
        "Desarrollo Web Full-Stack",
      ],
    },
    {
      id: 2,
      degree: "Certificación en Desarrollo Frontend",
      institution: "ITM (Instituto Tecnológico de Mérida)",
      period: "2020",
      location: "Mérida Yucatán, México",
      description:
        "Curso intensivo en desarrollo frontend utilizando HTML, CSS, JavaScript y frameworks modernos como React.",
      achievements: [
        "Desarrollo de una aplicación web completa como proyecto final",
        "Habilidades avanzadas en diseño responsivo y accesibilidad",
        "Experiencia con herramientas de control de versiones (Git)",
      ],
      courses: ["HTML5 y CSS3", "JavaScript ES6+", "React.js"],
    },
    {
      id: 3,
      degree: "Curso en Kubernetes y Orquestación de Contenedores",
      institution: "Udemy",
      period: "2023",
      location: "Online",
      description:
        "Capacitación en despliegue, gestión y escalado de aplicaciones en contenedores utilizando Kubernetes.",
      achievements: [
        "Implementación de clústeres de Kubernetes en entornos de producción",
        "Automatización de despliegues con Helm",
        "Monitoreo y logging con Prometheus y Grafana",
      ],
      courses: [
        "Fundamentos de Kubernetes",
        "Administración de Clústeres",
        "Redes en Kubernetes",
        "Seguridad y RBAC",
      ],
    },
  ];

  const certifications = [
    {
      name: "META Jr API Developer",
      issuer: "META Inc.",
      date: "2025",
      credentialId: "DCA-2025",
    },
    {
      name: "Ultimate Docker",
      issuer: "Udemy",
      date: "2025",
      credentialId: "UDC-2025",
    },
    {
      name: "Ciberseguridad Defensiva",
      issuer: "Udemy",
      date: "2025",
      credentialId: "CYB-2025",
    },
    {
      name: "Hacking Ético - Rastreo de Delincuentes",
      issuer: "Udemy",
      date: "2025",
      credentialId: "ETH-2025",
    },
  ];

  return (
    <>
      {/* ESTILOS CSS PUROS */}
      <style >{`
        .education-section {
          padding: 5rem 1rem;
          background-color: #f9fafb;
          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
        }

        .education-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 1rem;
        }

        .education-title {
          font-size: 2.5rem;
          font-weight: 700;
          text-align: center;
          color: #1f2937;
          margin-bottom: 3rem;
        }

        .education-card {
          background: white;
          border-radius: 1rem;
          padding: 2rem;
          margin-bottom: 2rem;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
          transition: all 0.3s ease;
        }

        .education-card:hover {
          box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
        }

        .education-header {
          display: flex;
          flex-direction: column;
          gap: 0.5rem;
          margin-bottom: 1.5rem;
        }

        @media (min-width: 768px) {
          .education-header {
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
          }
        }

        .education-degree {
          font-size: 1.5rem;
          font-weight: 700;
          color: #111827;
        }

        .education-institution {
          font-size: 1.25rem;
          font-weight: 600;
          color: #2563eb;
        }

        .education-period {
          display: inline-block;
          background-color: #dbeafe;
          color: #1d4ed8;
          padding: 0.25rem 0.75rem;
          border-radius: 9999px;
          font-size: 0.875rem;
          font-weight: 500;
        }

        .education-location {
          color: #4b5563;
          font-size: 0.9375rem;
          margin-top: 0.25rem;
        }

        .education-description {
          color: #4b5563;
          margin-bottom: 1.5rem;
          line-height: 1.6;
        }

        .education-grid {
          display: grid;
          gap: 1.5rem;
        }

        @media (min-width: 768px) {
          .education-grid {
            grid-template-columns: 1fr 1fr;
          }
        }

        .education-subtitle {
          font-weight: 600;
          color: #1f2937;
          margin-bottom: 0.75rem;
        }

        .education-list {
          display: flex;
          flex-direction: column;
          gap: 0.5rem;
        }

        .education-item {
          display: flex;
          align-items: flex-start;
          gap: 0.75rem;
        }

        .education-dot {
          width: 0.5rem;
          height: 0.5rem;
          background-color: #16a34a;
          border-radius: 9999px;
          margin-top: 0.375rem;
          flex-shrink: 0;
        }

        .education-courses {
          display: flex;
          flex-wrap: wrap;
          gap: 0.5rem;
        }

        .education-course {
          background-color: #f3f4f6;
          color: #374151;
          padding: 0.25rem 0.75rem;
          border-radius: 9999px;
          font-size: 0.875rem;
          font-weight: 500;
          transition: background-color 0.2s;
        }

        .education-course:hover {
          background-color: #e5e7eb;
        }

        .certifications-container {
          background: white;
          border-radius: 1rem;
          padding: 2rem;
          margin-top: 3rem;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
        }

        .certifications-title {
          font-size: 1.5rem;
          font-weight: 700;
          text-align: center;
          color: #1f2937;
          margin-bottom: 1.5rem;
        }

        .certifications-grid {
          display: grid;
          gap: 1.5rem;
        }

        @media (min-width: 768px) {
          .certifications-grid {
            grid-template-columns: repeat(3, 1fr);
          }
        }

        .certification-card {
          text-align: center;
          padding: 1.5rem;
          background-color: #f9fafb;
          border-radius: 1rem;
          transition: background-color 0.2s;
        }

        .certification-card:hover {
          background-color: #f3f4f6;
        }

        .certification-icon {
          width: 4rem;
          height: 4rem;
          background-color: #dbeafe;
          border-radius: 9999px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 1rem;
        }

        .certification-name {
          font-weight: 600;
          color: #111827;
          margin-bottom: 0.5rem;
        }

        .certification-issuer {
          color: #4b5563;
          font-size: 0.875rem;
          margin-bottom: 0.25rem;
        }

        .certification-date {
          color: #6b7280;
          font-size: 0.75rem;
          margin-bottom: 0.25rem;
        }

        .certification-id {
          color: #2563eb;
          font-family: monospace;
          font-size: 0.75rem;
        }

        /* Evita scroll horizontal */
        * {
          box-sizing: border-box;
        }

        body {
          margin: 0;
          overflow-x: hidden;
        }
      `}</style>

      <section id="educacion" className="education-section">
        <div className="education-container">
          <h2 className="education-title">Formación Académica</h2>

          {/* Educación */}
          <div style={{ maxWidth: "64rem", margin: "0 auto 3rem" }}>
            {education.map((edu) => (
              <div key={edu.id} className="education-card">
                <div className="education-header">
                  <div>
                    <h3 className="education-degree">{edu.degree}</h3>
                    <h4 className="education-institution">{edu.institution}</h4>
                  </div>
                  <div style={{ textAlign: "right" }}>
                    <span className="education-period">{edu.period}</span>
                    <p className="education-location">{edu.location}</p>
                  </div>
                </div>

                <p className="education-description">{edu.description}</p>

                <div className="education-grid">
                  <div>
                    <h4 className="education-subtitle">Logros:</h4>
                    <div className="education-list">
                      {edu.achievements.map((achievement, i) => (
                        <div key={i} className="education-item">
                          <div className="education-dot"></div>
                          <span style={{ color: "#4b5563" }}>{achievement}</span>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div>
                    <h4 className="education-subtitle">Cursos Relevantes:</h4>
                    <div className="education-courses">
                      {edu.courses.slice(0, 4).map((course, i) => (
                        <span key={i} className="education-course">
                          {course}
                        </span>
                      ))}
                      {edu.courses.length > 4 && (
                        <span className="education-course">
                          +{edu.courses.length - 4} más
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Certificaciones */}
          <div className="certifications-container">
            <h3 className="certifications-title">Certificaciones Profesionales</h3>

            <div className="certifications-grid">
              {certifications.map((cert, i) => (
                <div key={i} className="certification-card">
                  <div className="certification-icon">
                    <svg
                      className="w-8 h-8"
                      fill="none"
                      stroke="#2563eb"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                  </div>
                  <h4 className="certification-name">{cert.name}</h4>
                  <p className="certification-issuer">{cert.issuer}</p>
                  <p className="certification-date">{cert.date}</p>
                  <p className="certification-id">ID: {cert.credentialId}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Education;